import React from "react";

export default function NumberList({ content }) {
  return (
    <div
      className="number-list"
      style={{
        margin: content.component_margin ? content.component_margin : "0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {content.content.map((obj, i) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "200%",
              alignContent: "center",
              marginBottom: "10px",
            }}
          >
            <div className="number-circle">
              <span
                style={{
                  fontSize: "3.5rem",
                  paddingTop:
                    !window.navigator.platform.includes("Win") && "7px",
                  paddingRight: "2px",
                  color: "white",
                  textAlign: "baseline",
                  lineHeight: "58px",
                }}
              >
                {i + 1}
              </span>
            </div>
            <div style={{ alignSelf: "center" }}>
              {obj.large_text && (
                <p
                  class="body-text"
                  style={{
                    fontFamily: "LG_Smart_Bold",
                    color: "white",
                    margin: "15px 0 0 10px",
                    width: "100%",
                  }}
                >
                  {obj.large_text}
                </p>
              )}
              {obj.small_text && (
                <p
                  class="body-text"
                  style={{
                    color: "rgb(196, 197, 199)",
                    marginTop: "5px",
                    marginLeft: "10px",
                    marginBottom: "0",
                    width: "100%",
                  }}
                >
                  {obj.small_text}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
